<template>
	<section class="referrals section section--mini">
		<article class="referrals__item referral card" v-for="item in items" :key="item.id">
			<i class="referral__icon">
				<Icon name="mail" />
			</i>
			<span class="referral__name" v-if="item.referral_user.username">@{{ item.referral_user.username }}</span>
			<span class="referral__name" v-else>{{ item.referral_user.name }}</span>
			<span class="referral__amount" data-currency="USDT">+{{ item.amount.toFixed(2) }}</span>
		</article>
	</section>
</template>
<script lang="ts" setup>
import "./ReferralsView.scss";
import {computed, onMounted, ref, watch} from "vue";
import ReferralRewardEntity from "@/entities/ReferralEntity";
import Icon from "@/components/Icon/Icon.vue";
import {useApiStore} from "@/stores/apiStore";
import BalanceHistoryEntity from "@/entities/BalanceHistoryEntity";

interface Props{
	orderBy : 'asc' | 'desc'
}

let {api} = useApiStore();

let props = withDefaults(defineProps<Props>(), {
	orderBy: 'desc'
});

let items = ref<BalanceHistoryEntity[]>([]);
let loading = ref<boolean>(false);

async function loadReferrals(){

	loading.value = true;

	let referrals = await api.getReferrals(1, 100, {
		mode : props.orderBy,
		field : 'id'
	}, {
		type : 'referral'
	});

	items.value = referrals.items;
	loading.value = false;

}

onMounted(loadReferrals);
watch(() => props.orderBy, loadReferrals);

</script>